import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { ProductIndexItemInterface } from "../interfaces/apiV2/shared/ProductIndexItemInterface";

export interface SearchProductsResult {
    machines: ProductIndexItemInterface[];
    accessories: ProductIndexItemInterface[];
    old_models: ProductIndexItemInterface[];
}

export const searchApiSlice = createApi({
    reducerPath: "searchApi",
    baseQuery: apiBaseQuery(),
    endpoints: (builder) => ({
        searchProducts: builder.query<SearchProductsResult, { search: string }>(
            {
                query: ({ search }) => {
                    const searchParams = new URLSearchParams();
                    searchParams.set("filter[search]", search);

                    return `apiV2/dealer/products/search?${searchParams.toString()}`;
                },
                transformResponse: (response: { data: SearchProductsResult }) =>
                    response.data,
            },
        ),
    }),
});

export const { useLazySearchProductsQuery } = searchApiSlice;
